import { configureStore } from '@reduxjs/toolkit';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import authSlice from './slices/authSlice';
import podsSlice from './slices/podsSlice';
import projectsSlice from './slices/projectsSlice';
import forecastsSlice from './slices/forecastsSlice';
import retainersSlice from './slices/retainersSlice';
import timeEntriesSlice from './slices/timeEntriesSlice';
import permissionsSlice from './slices/permissionsSlice';

export const store = configureStore({
  reducer: {
    auth: authSlice,
    pods: podsSlice,
    projects: projectsSlice,
    forecasts: forecastsSlice,
    retainers: retainersSlice,
    timeEntries: timeEntriesSlice,
    permissions: permissionsSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Typed hooks
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
